
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/national-merit/crematorium/[companyname]",
      function () {
        return require("private-next-pages/national-merit/crematorium/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/national-merit/crematorium/[companyname]"])
      });
    }
  